import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonMenu,
  IonItem,
  IonList,
  IonMenuButton,
  IonButtons,
  IonButton,
  IonIcon,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonToggle,
  IonRange,
} from "@ionic/react";

// CSS
import "./SettingsPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconClose from "../../assets/Button_Close@3x.png";
import iconTextIncrease from "../../assets/Button_Text_Increase@3x.png";
import iconTextIncreaseDark from "../../assets/Button_Text_Increase_Dark@3x.png";
import iconTextDecrease from "../../assets/Button_Text_Decrease@3x.png";
import iconTextDecreaseDark from "../../assets/Button_Text_Decrease_Dark@3x.png";
import iconLineIncrease from "../../assets/Button_Line_Increase@3x.png";
import iconLineIncreaseDark from "../../assets/Button_Line_Increase_Dark@3x.png";
import iconLineDecrease from "../../assets/Button_Line_Decrease@3x.png";
import iconLineDecreaseDark from "../../assets/Button_Line_Decrease_Dark@3x.png";
import iconTickDark from "../../assets/Button_Tick_Dark@3x.png";
import toggleOn from "../../assets/Controls_Switches_Light_On@3x.png";
import toggleOff from "../../assets/Controls_Switches_Light_Off@3x.png";
import toggleOnDark from "../../assets/Controls_Switches_Dark_On@3x.png";
import toggleOffDark from "../../assets/Controls_Switches_Dark_Off@3x.png";

// Controllers
import { IScreenProps, IUser } from "../../Interfaces";
import { AlphaPicker, HuePicker } from "react-color";

// Components

type Props = { close?: () => void; screenProps: IScreenProps; features: string[] };
type State = {};

class SettingsPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  close() {
    if (this.props.close) {
      this.props.close();
    }
  }

  render() {
    let fontSizePercentage = 100 + this.props.screenProps.fontSizeChange * 10;

    let lineHeightPercentage = 100;
    switch (this.props.screenProps.lineHeightChange) {
      case 1:
        lineHeightPercentage = 80;
        break;
      case 1.5:
        lineHeightPercentage = 100;
        break;
      case 2:
        lineHeightPercentage = 120;
        break;
      case 2.5:
        lineHeightPercentage = 140;
        break;
      case 3:
        lineHeightPercentage = 160;
        break;
      case 3.5:
        lineHeightPercentage = 180;
        break;
      case 4:
        lineHeightPercentage = 200;
        break;

      default:
        break;
    }

    let isLowVisMode =
      this.props.screenProps.fontSizeChange === 5 &&
      this.props.screenProps.lineHeightChange === 3 &&
      this.props.screenProps.fontWeight === "bold";
    let isBoldText = this.props.screenProps.fontWeight === "bold";

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonTitle>Settings</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={this.close.bind(this)}>
                <img className="icon-44" src={iconClose} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="modalContent">
          <div className="settingsLabelContainer">
            <div className="settingsLabel">TEXT OPTIONS</div>
            <IonButton
              mode="ios"
              className="clearButton"
              onClick={() => {
                this.props.screenProps.resetFontSize();
                this.props.screenProps.resetLineHeight();
                this.props.screenProps.setFontWeight("400");
              }}
            >
              Reset
            </IonButton>
          </div>

          <div className="settingsFontPickerContainer">
            <IonButton
              fill="clear"
              mode="ios"
              className="settingsFontButton"
              onClick={this.props.screenProps.decreaseFontSize.bind(this)}
            >
              <img
                className="settingsFontImage"
                src={this.props.screenProps.darkMode ? iconTextDecreaseDark : iconTextDecrease}
                alt="Decrease font size"
              />
            </IonButton>
            <div className="settingsFontSeparator" />
            <div className="settingsFontPercentageText">{fontSizePercentage}%</div>
            <div className="settingsFontSeparator" />
            <IonButton
              fill="clear"
              mode="ios"
              className="settingsFontButton"
              onClick={this.props.screenProps.increaseFontSize.bind(this)}
            >
              <img
                className="settingsFontImage"
                src={this.props.screenProps.darkMode ? iconTextIncreaseDark : iconTextIncrease}
                alt="Increase font size"
              />
            </IonButton>
          </div>
          <div className="settingsFontPickerContainer">
            <IonButton
              fill="clear"
              mode="ios"
              className="settingsFontButton"
              onClick={this.props.screenProps.decreaseLineHeight.bind(this)}
            >
              <img
                className="settingsFontImage"
                src={this.props.screenProps.darkMode ? iconLineDecreaseDark : iconLineDecrease}
                alt="Decrease line height"
              />
            </IonButton>
            <div className="settingsFontSeparator" />
            <div className="settingsFontPercentageText">{lineHeightPercentage}%</div>
            <div className="settingsFontSeparator" />
            <IonButton
              fill="clear"
              mode="ios"
              className="settingsFontButton"
              onClick={this.props.screenProps.increaseLineHeight.bind(this)}
            >
              <img
                className="settingsFontImage"
                src={this.props.screenProps.darkMode ? iconLineIncreaseDark : iconLineIncrease}
                alt="Increase line height"
              />
            </IonButton>
          </div>

          <div className="settingsRow">
            <div>Bold text</div>
            {/* <IonToggle color="success" mode='ios' checked={this.props.screenProps.fontWeight === 'bold'} onIonChange={e => {
                if (e.detail.checked) {
                  this.props.screenProps.setFontWeight('bold');
                } else {
                  this.props.screenProps.setFontWeight('400');
                }
              }} /> */}
            <div
              className="fontPopoverToggle"
              onClick={() => {
                this.props.screenProps.setFontWeight(isBoldText ? "400" : "bold");
              }}
            >
              <img
                className="icon-toggle"
                src={
                  isBoldText
                    ? this.props.screenProps.darkMode
                      ? toggleOnDark
                      : toggleOn
                    : this.props.screenProps.darkMode
                    ? toggleOffDark
                    : toggleOff
                }
                alt=""
              />
            </div>
          </div>
          <div className="settingsRow">
            <div>Low vis mode</div>
            {/* <IonToggle color="success" mode='ios' checked={this.props.screenProps.lowVisMode} onIonChange={e => {this.props.screenProps.setLowVisMode(e.detail.checked)}} /> */}
            <div
              className="fontPopoverToggle"
              onClick={() => {
                this.props.screenProps.setLowVisMode(!isLowVisMode);
              }}
            >
              <img
                className="icon-toggle"
                src={
                  isLowVisMode
                    ? this.props.screenProps.darkMode
                      ? toggleOnDark
                      : toggleOn
                    : this.props.screenProps.darkMode
                    ? toggleOffDark
                    : toggleOff
                }
                alt=""
              />
            </div>
          </div>

          {/* <IonButton fill="clear" mode="ios" className="settingsFontReset" onClick={this.props.screenProps.resetFontSize.bind(this)}>
            Reset
          </IonButton> */}

          <div className="settingsSampleTextContainer">
            <div className="settingSampleText" style={{ lineHeight: this.props.screenProps.lineHeightChange }}>
              Change the text size and line height to suit you. This can also be changed inside a guideline by tapping
              the accessibility button in the nav bar.
            </div>
          </div>

          <div className="settingsLabel">FONTS</div>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Inter")}>
            <div className="fontPopoverTitle fontPopoverTitleInter">Default (Inter)</div>
            {this.props.screenProps.selectedFontFamily === "Inter" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "AtkinsonHyperlegible")}>
            <div className="fontPopoverTitle fontPopoverTitleAtkinsonHyperlegible">Atkinson Hyperlegible</div>
            {this.props.screenProps.selectedFontFamily === "AtkinsonHyperlegible" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Comic Sans MS")}>
            <div className="fontPopoverTitle fontPopoverTitleComicSans">Comic Sans</div>
            {this.props.screenProps.selectedFontFamily === "Comic Sans MS" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "OpenDyslexic")}>
            <div className="fontPopoverTitle fontPopoverTitleOpenDyslexic">OpenDyslexic</div>
            {this.props.screenProps.selectedFontFamily === "OpenDyslexic" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Roboto")}>
            <div className="fontPopoverTitle fontPopoverTitleRoboto">Roboto</div>
            {this.props.screenProps.selectedFontFamily === "Roboto" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "RobotoSerif")}>
            <div className="fontPopoverTitle fontPopoverTitleRobotoSerif">Roboto Serif</div>
            {this.props.screenProps.selectedFontFamily === "RobotoSerif" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <IonItem onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Verdana")}>
            <div className="fontPopoverTitle fontPopoverTitleVerdana">Verdana</div>
            {this.props.screenProps.selectedFontFamily === "Verdana" ? (
              <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
            ) : null}
          </IonItem>

          <div className="settingsLabel">SPEECH</div>

          <IonItem>
            <IonLabel>Show text-to-speech</IonLabel>
            <IonToggle
              color="success"
              mode="ios"
              checked={this.props.screenProps.showTextToSpeech}
              onIonChange={(e) => this.props.screenProps.setShowTextToSpeech(e.detail.checked)}
            />
          </IonItem>

          {this.props.screenProps.showTextToSpeech ? (
            <IonItem>
              <IonLabel>Speech speed</IonLabel>
              <IonRange
                mode="ios"
                value={this.props.screenProps.textToSpeechSpeed}
                ticks={false}
                snaps={true}
                min={1}
                max={9}
                onIonChange={(e) => this.props.screenProps.setTextToSpeechSpeed(e.detail.value as any)}
              />
            </IonItem>
          ) : null}

          <div className="settingsLabel">Display</div>

          <IonList>
            <IonItem>
              <IonSegment
                mode="ios"
                onIonChange={(e) => {
                  if (e.detail.value === "Auto" || e.detail.value === "Light" || e.detail.value === "Dark") {
                    this.props.screenProps.setAppearance(e.detail.value);
                  }
                }}
                value={this.props.screenProps.appearance}
              >
                <IonSegmentButton value="Auto">
                  <IonLabel>Auto</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="Light">
                  <IonLabel>Light</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="Dark">
                  <IonLabel>Dark</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonItem>

            <IonItem>
              <IonLabel>Underline buttons</IonLabel>
              <IonToggle
                color="success"
                mode="ios"
                checked={this.props.screenProps.accessabilityUnderlineLinks}
                onIonChange={(e) => this.props.screenProps.setAccessabilityUnderlineLinks(e.detail.checked)}
              />
            </IonItem>

            <IonItem>
              <IonLabel>Colour Filter</IonLabel>
              <IonToggle
                color="success"
                mode="ios"
                checked={this.props.screenProps.showColorFilter}
                onIonChange={(e) => this.props.screenProps.setShowColorFilter(e.detail.checked)}
              />
            </IonItem>

            {this.props.screenProps.showColorFilter ? (
              <IonItem>
                <div className="fontPopoverAppearance fontPopoverAppearanceSettingsMenu">
                  <HuePicker
                    width="100%"
                    color={this.props.screenProps.filterColor}
                    onChange={(color) =>
                      this.props.screenProps.setFilterColor({
                        r: color.rgb.r,
                        g: color.rgb.g,
                        b: color.rgb.b,
                        a: this.props.screenProps.filterColor.a,
                      })
                    }
                  />
                  <div className="fontPopoverApperanceSeparator" />
                  <AlphaPicker
                    width="100%"
                    color={this.props.screenProps.filterColor}
                    onChange={(color) =>
                      this.props.screenProps.setFilterColor({
                        r: color.rgb.r,
                        g: color.rgb.g,
                        b: color.rgb.b,
                        a: color.rgb.a != null && color.rgb.a < 0.8 ? color.rgb.a : 0.8,
                      })
                    }
                  />
                </div>
              </IonItem>
            ) : null}

            {this.props.features.includes("freezeFirstColumnMedTable") ? (
              <IonItem>
                <IonLabel>Freeze first column in meds tables</IonLabel>
                <IonToggle
                  color="success"
                  mode="ios"
                  checked={this.props.screenProps.freezeFirstDrugColumn}
                  onIonChange={(e) => this.props.screenProps.setFreezeFirstDrugColumn(e.detail.checked)}
                />
              </IonItem>
            ) : null}

            {this.props.screenProps.keepScreenAwakeSupported ? (
              <IonItem>
                <IonLabel>Always On</IonLabel>
                <IonToggle
                  color="success"
                  mode="ios"
                  checked={this.props.screenProps.keepScreenAwake}
                  onIonChange={(e) => this.props.screenProps.setKeepScreenAwake(e.detail.checked)}
                />
              </IonItem>
            ) : null}
          </IonList>

          <div className="settingsLabel">PARAPASS</div>

          <IonList>
            <IonItem>
              <IonLabel>Hide ParaPass links</IonLabel>
              <IonToggle
                color="success"
                mode="ios"
                checked={this.props.screenProps.hideParaPassLinks}
                onIonChange={(e) => this.props.screenProps.setHideParaPassLinks(e.detail.checked)}
              />
            </IonItem>
          </IonList>

          <br />
          <br />
          <br />
          <br />
        </IonContent>
      </IonPage>
    );
  }
}

export default SettingsPage;
